<template>
  <div>
    <v-row class="mx-1">
      <v-col>
        <v-btn-toggle v-model="fareSection" mandatory color="primary">
          <v-btn outlined class="px-12">시내</v-btn>
          <v-btn outlined class="px-12">시외</v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col class="d-flex justify-end">
        <c-btn v-if="this.$store.state.userInfo.role === 'SA'" outlined color="blue" iconName="mdi-pencil" @click="onClickSaveToggle">{{!saveToggle ? '수정':'저장' }}</c-btn>
        <c-btn class="mx-1" color="grey" outlined iconName="mdi-format-list-bulleted-square" @click="$router.go(-1)" >
          돌아가기
        </c-btn>
      </v-col>
    </v-row>

    <div v-show="fareSection === 0">
      <v-row class="mx-1">
        <v-col cols="12">
          <c-card outlined>
            <v-row>
              <v-col cols="3">주행 요금</v-col>
              <v-radio-group row dense v-model="selectedDowntown" mandatory :disabled="!saveToggle">
                <v-radio
                    v-for="fareType in downtownFareTypes"
                    :label="fareType.label"
                    :value="fareType.value"
                ></v-radio>
              </v-radio-group>
            </v-row>
            <!-- radio를 바꿔도 값을 유지하기위해 v-show 사용-->
            <time-base v-show="selectedDowntown==='fr_time'" :is-default-fee="true" :fare-info.sync="downtown.timeDriveFareList" :input-state="saveToggle"></time-base>
            <distance-base v-show="selectedDowntown==='fr_distance'" :fare-info.sync="downtown.distanceDriveFareList" :input-state="saveToggle"></distance-base>
          </c-card>
        </v-col>

        <v-col cols="12">
          <c-card outlined>
            <v-row>
              <v-col cols="3">대기 요금</v-col>
              <v-radio-group row dense v-model="downtown.isWaitFare" mandatory :disabled="!saveToggle">
                <v-radio
                    v-for="fareType in downtownWaitFareTypes"
                    :label="fareType.label"
                    :value="fareType.value"
                ></v-radio>
              </v-radio-group>
            </v-row>
            <time-base v-show="downtown.isWaitFare === 'fr_wait_t'" :is-free-offer="true" :fare-info.sync="downtown.timeWaitFareList" :input-state="saveToggle"></time-base>
            <area-time-base v-show="downtown.isWaitFare ==='fr_wait_at'" :is-free-offer="true" :fare-info.sync="downtown.areaTimeWaitFareList" :input-state="saveToggle"></area-time-base>
          </c-card>
        </v-col>

        <v-col cols="12">
          <c-card outlined>
            <v-row>
              <v-col cols="3">도움 요금</v-col>
              <v-radio-group row dense v-model="downtown.isAssistFare" mandatory :disabled="!saveToggle">
                <v-radio
                    v-for="fareType in downtownAssistFareTypes"
                    :label="fareType.label"
                    :value="fareType.value"
                ></v-radio>
              </v-radio-group>
            </v-row>
            <time-base v-show="downtown.isAssistFare === 'fr_help_t'" :is-free-offer="true" :fare-info.sync="downtown.timeAssistFareList" :input-state="saveToggle"></time-base>
            <area-time-base v-show="downtown.isAssistFare==='fr_help_at'" :is-free-offer="true" :fare-info.sync="downtown.areaTimeAssistFareList" :input-state="saveToggle"></area-time-base>
          </c-card>
        </v-col>

        <v-col cols="12">
          <c-card outlined>
            <v-row>
              <v-col cols="3">배송 요금</v-col>
              <v-radio-group row dense v-model="downtown.isDeliveryFare" mandatory :disabled="!saveToggle" :input-state="saveToggle">
                <v-radio
                    v-for="fareType in extraFareTypes"
                    :label="fareType.label"
                    :value="fareType.value"
                ></v-radio>
              </v-radio-group>
            </v-row>
            <distance-base v-show="downtown.isDeliveryFare" :fare-info.sync="downtown.deliveryFareList" :input-state="saveToggle"></distance-base>
          </c-card>
        </v-col>
      </v-row>
    </div>
    <div v-show="fareSection===1">
      <v-row class="mx-1">
        <v-col cols="12">
          <c-card outlined>
            <v-row>
              <v-col cols="3">주행 요금</v-col>
              <v-radio-group row dense v-model="selectedSuburban" mandatory :disabled="!saveToggle">
                <v-radio
                    v-for="fareType in suburbanFareTypes"
                    :label="fareType.label"
                    :value="fareType.value"
                ></v-radio>
              </v-radio-group>
            </v-row>
            <time-base v-show="selectedSuburban==='suburban_fr_time'" :is-default-fee="true" :fare-info.sync="suburban.timeDriveFareList" :input-state="saveToggle"></time-base>
            <distance-base v-show="selectedSuburban==='suburban_fr_distance'" :fare-info.sync="suburban.distanceDriveFareList" :input-state="saveToggle"></distance-base>
            <area-base v-show="selectedSuburban==='suburban_fr_area'" :fare-info.sync="suburban.areaDriveFareList" :input-state="saveToggle"></area-base>
          </c-card>
        </v-col>

        <v-col cols="12">
          <c-card outlined>
            <v-row>
              <v-col cols="3">대기 요금</v-col>
              <v-radio-group row dense v-model="suburban.isWaitFare" mandatory :disabled="!saveToggle">
                <v-radio
                    v-for="fareType in suburbanWaitFareTypes"
                    :label="fareType.label"
                    :value="fareType.value"
                ></v-radio>
              </v-radio-group>
            </v-row>
            <time-base v-show="suburban.isWaitFare === 'suburban_fr_wait_t'" :is-free-offer="true" :fare-info.sync="suburban.timeWaitFareList" :input-state="saveToggle"></time-base>
            <area-time-base v-show="suburban.isWaitFare ==='suburban_fr_wait_at'" :is-free-offer="true" :fare-info.sync="suburban.areaTimeWaitFareList" :input-state="saveToggle"></area-time-base>
          </c-card>
        </v-col>

        <v-col cols="12">
          <c-card outlined>
            <v-row>
              <v-col cols="3">도움 요금</v-col>
              <v-radio-group row dense v-model="suburban.isAssistFare" mandatory :disabled="!saveToggle">
                <v-radio
                    v-for="fareType in suburbanAssistFareTypes"
                    :label="fareType.label"
                    :value="fareType.value"
                ></v-radio>
              </v-radio-group>
            </v-row>
            <time-base v-show="suburban.isAssistFare === 'suburban_fr_help_t'" :is-free-offer="true" :fare-info.sync="suburban.timeAssistFareList" :input-state="saveToggle"></time-base>
            <area-time-base v-show="suburban.isAssistFare === 'suburban_fr_help_at'" :is-free-offer="true" :fare-info.sync="suburban.areaTimeAssistFareList" :input-state="saveToggle"></area-time-base>
          </c-card>
        </v-col>

        <v-col cols="12">
          <c-card outlined>
            <v-row>
              <v-col cols="3">배송 요금</v-col>
              <v-radio-group row dense v-model="suburban.deliveryFareType" mandatory :disabled="!saveToggle">
                <v-radio
                    v-for="fareType in suburbanDeliveryFareTypes"
                    :label="fareType.label"
                    :value="fareType.value"
                ></v-radio>
              </v-radio-group>
            </v-row>
            <distance-base v-show="suburban.deliveryFareType === 'suburban_fr_delivery_distance'" :fare-info.sync="suburban.distanceDeliveryFareList" :input-state="saveToggle"></distance-base>
            <area-base v-show="suburban.deliveryFareType==='suburban_fr_delivery_area'" :fare-info.sync="suburban.areaDeliveryFareList" :input-state="saveToggle"></area-base>
          </c-card>
        </v-col>
      </v-row>

    </div>
  </div>
</template>

<script>
import TimeBase from "@/views/Default/Center/Fare/TimeBase";
import DistanceBase from "@/views/Default/Center/Fare/DistanceBase";
import AreaBase from "@/views/Default/Center/Fare/AreaBase";
import AreaTimeBase from "@/views/Default/Center/Fare/AreaTimeBase";

export default {
  name: "CenterFare",
  components:{TimeBase, DistanceBase, AreaBase, AreaTimeBase},
  data() {
    return {
      isUpdate: false,
      saveToggle: false,
      fareSection: 0,
      downtownFareList: [],
      suburbanFareList:[],

      downtownFareTypes: [
        {label: '시간 요금제', value: 'fr_time'},
        {label: '거리 요금제', value: 'fr_distance'},
      ],
      suburbanFareTypes: [
        {label: '거리 요금제', value: 'suburban_fr_distance'},
        {label: '시간 요금제', value: 'suburban_fr_time'},
        {label: '구간 요금제', value: 'suburban_fr_area'},
      ],
      suburbanDeliveryFareTypes: [
        {label: '거리 요금제', value: 'suburban_fr_delivery_distance'},
        {label: '구간 요금제', value: 'suburban_fr_delivery_area'},
      ],
      downtownWaitFareTypes: [
        {label: '없음', value: null},
        {label: '시간 요금제', value: 'fr_wait_t'},
        {label: '구간 요금제', value: 'fr_wait_at'},
      ],
      downtownAssistFareTypes: [
        {label: '없음', value: null},
        {label: '시간 요금제', value: 'fr_help_t'},
        {label: '구간 요금제', value: 'fr_help_at'},
      ],
      suburbanWaitFareTypes: [
        {label: '없음', value: null},
        {label: '시간 요금제', value: 'suburban_fr_wait_t'},
        {label: '구간 요금제', value: 'suburban_fr_wait_at'},
      ],
      suburbanAssistFareTypes: [
        {label: '없음', value: null},
        {label: '시간 요금제', value: 'suburban_fr_help_t'},
        {label: '구간 요금제', value: 'suburban_fr_help_at'},
      ],
      extraFareTypes: [
        {label: '있음', value: true},
        {label: '없음', value: false},
      ],
      selectedDowntown:'',
      selectedSuburban:'',
      //시내요금
      downtown: {
        isWaitFare: null,
        isAssistFare: null,
        isDeliveryFare: false,

        distanceDriveFareList: [],
        timeDriveFareList: [],
        timeWaitFareList:[],
        areaTimeWaitFareList: [],
        timeAssistFareList:[],
        areaTimeAssistFareList: [],
        deliveryFareList:[],
      },

      //시외요금
      suburban: {
        isWaitFare: null,
        isAssistFare: null,
        deliveryFareType: '',

        distanceDriveFareList: [],
        timeDriveFareList: [],
        areaDriveFareList:[],
        timeWaitFareList:[],
        areaTimeWaitFareList: [],
        timeAssistFareList:[],
        areaTimeAssistFareList: [],
        distanceDeliveryFareList:[],
        areaDeliveryFareList: [],
      },
    }
  },
  methods: {
    async getFareList() {
      try {
        const centerId = this.$route.params.centerId;
        let res = await this.$api.getFareInfoList(centerId);
        this.isUpdate = res.data.length > 0;
        let downtown = [];
        let suburban = [];
        for(const fare of res.data) {
          if(fare.type.includes('suburban')) {
            suburban.push(fare);
          } else {
            downtown.push(fare);
          }
        }
        if(downtown.length > 0) {
          this.downtownFareList = downtown;
          this.parseDowntown();
        }
        if(suburban.length > 0) {
          this.suburbanFareList = suburban;
          this.parseSuburban();
        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'getFareList'});
      }
    },
    onClickSaveToggle() {
      //'저장' 버튼 클릭시에는 alert을 띄워준다
      if(this.saveToggle) {
        this.$store.commit('alert',
            {
              open: true, persistent: true, msg: '변경사항을 저장하시겠습니까?', confirmBoth: true,
              callBack: () => {
                this.reqSaveFare();
              },
              callBackCancel: () => {
                this.getFareList();
                this.saveToggle = false;
              }
            })
      } else {
        this.saveToggle = true;
      }
    },
    async reqSaveFare() {
      try {

        if(this.fieldCheck()) {
          this.saveToggle = false;
          await this.saveFareInfoList();
          await this.saveCenterFareInfo();
          await this.getFareList();

          this.$store.commit('snackbar', {color:'blue', msg: '요금제가 저장되었습니다.'});
          this.fareSection = 0;

        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'reqSaveFare'});
      }
    },
    async saveFareInfoList() {
      try {
        const request = {
          centerId: this.$route.params.centerId,
          isUpdate: this.isUpdate,
          fareInfoList: [...this.downtownFareList, ...this.suburbanFareList]
        }
        await this.$api.saveFareInfoList(request);
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'saveFareInfoList'});
      }
    },
    async saveCenterFareInfo() {
      try  {
        const data = {
          centerId: this.$route.params.centerId,
          fareType: this.selectedDowntown,
          suburbanFareType: this.selectedSuburban,
          suburbanDeliveryFareType: this.suburban.deliveryFareType,
          waitFareType: this.downtown.isWaitFare === 0 ? null : this.downtown.isWaitFare,
          helpFareType: this.downtown.isAssistFare === 0 ? null : this.downtown.isAssistFare,
          deliveryFareWhether: this.downtown.isDeliveryFare
        }
        await this.$api.updateCenterFareInfo(data);
      } catch (err) {
      }
    },
    fieldCheck() {
      let fareInfoList= [...this.downtownFareList, ...this.suburbanFareList];
      fareInfoList = fareInfoList.reduce((carry, el) => {
        let group = el['type'];
        if(!carry[group]) {
          carry[group] = [];
        }
        carry[group].push(el);
        return carry;
      }, {})

/*  fieldCheck 순서
  1. 숫자만 입력
  2. endValue가 startValue보다 큰지 체크
  3. unitValue는  1 이상이어야함 (추가요금만 해당, 마지막 추가요금은 체크하지 않는다.) *구간요금제 미해당
  4. null(empty field)  체크
  5. unitValue 가 (end-start) 배수인지 체크 (추가요금만 해당, 마지막 추가요금은 체크하지 않는다.) *구간요금제 미해당
  */
      for (let key in fareInfoList) {
        let type = fareInfoList[key];
        let isNotNull = true;
        let isValidUnit = true;
        let isNumberOnly = true;
        let isUnitMoreThanZero = true;
        let isGreaterNumber = true;

        isNumberOnly = this.checkIsNumberOnly(type);
        if(!isNumberOnly) return false;

        isGreaterNumber = this.checkIsGreaterNumber(type);
        if(!isGreaterNumber) return false;

        if(key.includes('area')) {
          isNotNull =this.checkAreaIsNull(type);
          if(!isNotNull) return false;
        } else{
          isUnitMoreThanZero = this.checkIsUnitValueMin(type, key);
          if(!isUnitMoreThanZero) return false;

          isNotNull = this.checkIsNull(type)
          if(!isNotNull) return false;

          isValidUnit = this.checkIsValidUnit(type, key)
          if(!isValidUnit) return false;
        }
      }
      return true;
    },
    checkAreaIsNull(list) {
      for(const item of list) {
        if(item.areaDescription === null || item.areaDescription === ''
        || item.unitFare === null || item.unitFare === ''
        ) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
          return false;
        }
      }
      return true;
    },
    checkIsNumberOnly(list) {
      for(let idx in list) {
        const fare = list[idx];
        if(isNaN(Number(fare.startValue)) || isNaN(Number(fare.endValue)) || isNaN(Number(fare.unitValue)) || isNaN(Number(fare.unitFare))) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '숫자만 입력해주세요.'});
          return false;
        }
      }
      return true;
    },
    checkIsGreaterNumber(list) {
      for(let idx in list) {
        const fare = list[idx];
          if (Number(fare.startValue) !== 0 && fare.endValue !== null && fare.endValue !== '' && Number(fare.startValue) >= Number(fare.endValue)) {
            if(fare.type.includes('distance')) this.$store.commit('snackbar', {timeout: 2000, msg: '시작 시점이 종료 시점보다 큽니다.'});
            else this.$store.commit('snackbar', {timeout: 2000, msg: '시작 시간이 종료 시간보다 큽니다.'});

            return false;
          }
      }
      return true;
    },
    checkIsNull(list) {
      for(let idx in list) {
        idx = Number(idx);
        const fare = list[idx];
        if(idx === list.length-1) {
          if((fare.startValue === null || fare.startValue === '')
              || (fare.unitFare === null || fare.unitFare === '')
              || (fare.unitValue === null || fare.unitValue === '')
            ) {
            this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
            return false;
          }
        } else {
          if((fare.startValue === null || fare.startValue === '')
              || (fare.endValue === null || fare.endValue === '')
              || (fare.unitFare === null || fare.unitFare === '')
              || (fare.unitValue === null || fare.unitValue === '')
          ) {
            this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
            return false;
          }
        }
      }
      return true;
    },
    checkIsUnitValueMin(list, key) {
      for (let i = 1; i <= list.length - 1; i++) {
        let unit = key.includes('distance') || key.includes('delivery') ? 'm당': '분 당';
        const unitValue = Number(list[i].unitValue);
        if(unitValue < 1) {
          this.$store.commit('snackbar', {timeout: 2000, msg: `"${unit}" 항목은 최소 1 이상이어야 합니다.`});
          return false;
        }
      }
      return true;
    },
    checkIsValidUnit(list, key) {
      for (let i = 1; i < list.length - 1; i++) {
        let unit = key.includes('distance') || key.includes('delivery') ? 'm당': '분 당';
        const endValue = key.includes('distance') || key.includes('delivery') ?  list[i].endValue*1000 : list[i].endValue;
        const startValue = key.includes('distance') || key.includes('delivery') ? list[i].startValue*1000 : list[i].startValue;
        if ((endValue - startValue) % list[i].unitValue !== 0) {
          this.$store.commit('snackbar', {timeout: 2000, msg: `"${unit}" 항목에 올바른 값을 입력해주세요.`});
          return false;
        }
      }
      return true;
    },
    parseDowntown() {
      let driveFare = [];
      let waitFare = [];
      let assistFare = [];
      let deliveryFare = [];
      let driveFareType = '';

      for(const item of this.downtownFareList) {
        const type = item.type;
        if(type === 'fr_time' || type === 'fr_distance') {
          driveFare.push(item);
        } else if(type === 'fr_wait_t' || type === 'fr_wait_at') {
          waitFare.push(item);
        } else if(type === 'fr_help_t' || type === 'fr_help_at') {
          assistFare.push(item);
        } else if(type === 'fr_delivery') {
          deliveryFare.push(item);
        }
      }

      if(driveFare.length > 0) {
        driveFareType = driveFare[0].type;
        this.selectedDowntown = driveFareType;
        if(driveFareType === 'fr_time') {
          this.downtown.timeDriveFareList = driveFare;
        } else {
          this.downtown.distanceDriveFareList = driveFare;
        }
      }

      if(waitFare.length > 0) {
        this.downtown.isWaitFare = waitFare[0].type;
        if(this.downtown.isWaitFare === 'fr_wait_t') {
          this.downtown.timeWaitFareList = waitFare;
        } else {
          this.downtown.areaTimeWaitFareList = waitFare;
        }
      }

      if(assistFare.length > 0) {
        this.downtown.isAssistFare = assistFare[0].type;
        if(this.downtown.isAssistFare === 'fr_help_t') {
          this.downtown.timeAssistFareList = assistFare;
        } else {
          this.downtown.areaTimeAssistFareList = assistFare;
        }
      }

      if(deliveryFare.length > 0) {
        this.downtown.isDeliveryFare = true;
        this.downtown.deliveryFareList = deliveryFare;
      }
    },
    makeDowntownFare() {
      let downtownFareList = [];
      const target = this.selectedDowntown === 'fr_time' ? this.downtown.timeDriveFareList : this.downtown.distanceDriveFareList;

      //주행요금 생성
      for(const item of target) {
        downtownFareList.push({
          type: this.selectedDowntown,
          ...item
        });
      }

      if(this.downtown.isWaitFare) {
        const target = this.downtown.isWaitFare === 'fr_wait_t' ? this.downtown.timeWaitFareList : this.downtown.areaTimeWaitFareList
        for(const item of target) {
          downtownFareList.push({
            type: this.downtown.isWaitFare,
            ...item
          });
        }
      }

      if(this.downtown.isAssistFare) {
        const target = this.downtown.isAssistFare === 'fr_help_t' ? this.downtown.timeAssistFareList : this.downtown.areaTimeAssistFareList
        for(const item of target) {
          downtownFareList.push({
            type: this.downtown.isAssistFare,
            ...item
          });
        }
      }

      if(this.downtown.isDeliveryFare) {
        for(const item of this.downtown.deliveryFareList) {
          downtownFareList.push({
            type: 'fr_delivery',
            ...item
          });
        }
      }
      this.downtownFareList = downtownFareList;
    },
    parseSuburban() {
      let driveFare = [];
      let waitFare = [];
      let assistFare = [];
      let deliveryFare = [];
      let driveFareType = '';
      let deliveryFareType ='';

      for(const item of this.suburbanFareList) {

        const type = item.type;
        if(type === 'suburban_fr_distance' || type === 'suburban_fr_time' || type === 'suburban_fr_area') {
          driveFare.push(item);
        } else if(type === 'suburban_fr_wait_t' || type === 'suburban_fr_wait_at') {
          waitFare.push(item);
        } else if(type === 'suburban_fr_help_t' || type === 'suburban_fr_help_at') {
          assistFare.push(item);
        } else if(type === 'suburban_fr_delivery_distance' || type ==='suburban_fr_delivery_area') {
          deliveryFare.push(item);
        }
      }

      if(driveFare.length > 0) {
        driveFareType = driveFare[0].type;
        this.selectedSuburban = driveFareType;
        if(driveFareType === 'suburban_fr_distance') {
          this.suburban.distanceDriveFareList = driveFare;
        } else if(driveFareType === 'suburban_fr_time') {
          this.suburban.timeDriveFareList = driveFare;
        } else {
          this.suburban.areaDriveFareList = driveFare;
        }
      }

      if(waitFare.length > 0) {
        this.suburban.isWaitFare = waitFare[0].type;
        if(this.suburban.isWaitFare === 'suburban_fr_wait_t') {
          this.suburban.timeWaitFareList = waitFare;
        } else {
          this.suburban.areaTimeWaitFareList = waitFare;
        }
      }

      if(assistFare.length > 0) {
        this.suburban.isAssistFare = assistFare[0].type;
        if(this.suburban.isAssistFare === 'suburban_fr_help_t') {
          this.suburban.timeAssistFareList = assistFare;
        } else {
          this.suburban.areaTimeAssistFareList = assistFare;
        }
      }

      if(deliveryFare.length > 0) {
        deliveryFareType = deliveryFare[0].type;
        this.suburban.deliveryFareType = deliveryFareType;
        if(deliveryFareType === 'suburban_fr_delivery_distance') {
          this.suburban.distanceDeliveryFareList = deliveryFare;
        } else if(deliveryFareType=== 'suburban_fr_delivery_area') {
          this.suburban.areaDeliveryFareList = deliveryFare
        }
      }
    },
    makeSuburbanFare() {
      let suburbanFareList = [];
      const target = this.selectedSuburban === 'suburban_fr_distance' ? this.suburban.distanceDriveFareList
          : this.selectedSuburban === 'suburban_fr_time' ? this.suburban.timeDriveFareList : this.suburban.areaDriveFareList;

      for(const item of target) {
        suburbanFareList.push({
          type: this.selectedSuburban,
          ...item
        });
      }

      if(this.suburban.isWaitFare) {
        const target = this.suburban.isWaitFare === 'suburban_fr_wait_t' ? this.suburban.timeWaitFareList : this.suburban.areaTimeWaitFareList;
        for(const item of target) {
          suburbanFareList.push({
            type: this.suburban.isWaitFare,
            ...item
          });
        }
      }

      if(this.suburban.isAssistFare) {
        const target = this.suburban.isAssistFare === 'suburban_fr_help_t' ? this.suburban.timeAssistFareList : this.suburban.areaTimeAssistFareList;
        for(const item of target) {
          suburbanFareList.push({
            type: this.suburban.isAssistFare,
            ...item
          });
        }
      }

      const deliveryTarget = this.suburban.deliveryFareType === 'suburban_fr_delivery_distance' ? this.suburban.distanceDeliveryFareList : this.suburban.areaDeliveryFareList;
      for(const item of deliveryTarget) {
        suburbanFareList.push({
          type: this.suburban.deliveryFareType,
          ...item
        });
      }

      this.suburbanFareList = suburbanFareList;
    },
  },
  mounted() {
    this.getFareList();
  },
  watch:{
    selectedDowntown() {
      this.makeDowntownFare();
    },
    'downtown.distanceDriveFareList': {
      deep: true,
      handler() {
        this.makeDowntownFare();
      }
    },
    'downtown.timeDriveFareList': {
      deep: true,
      handler() {
        this.makeDowntownFare();
      }
    },
    'downtown.isWaitFare': {
      deep: true,
      handler() {
        this.makeDowntownFare();
      }
    },
    'downtown.timeWaitFareList': {
      deep: true,
      handler() {
        this.makeDowntownFare();
      }
    },
    'downtown.areaTimeWaitFareList': {
      deep: true,
      handler() {
        this.makeDowntownFare();
      }
    },
    'downtown.isAssistFare': {
      deep: true,
      handler() {
        this.makeDowntownFare();
      }
    },
    'downtown.timeAssistFareList': {
      deep: true,
      handler() {
        this.makeDowntownFare();
      }
    },
    'downtown.areaTimeAssistFareList': {
      deep: true,
      handler() {
        this.makeDowntownFare();
      }
    },
    'downtown.isDeliveryFare': {
      deep: true,
      handler() {
        this.makeDowntownFare();
      }
    },
    'downtown.deliveryFareList': {
      deep: true,
      handler() {
        this.makeDowntownFare();
      }
    },

    selectedSuburban() {
      this.makeSuburbanFare();
    },
    'suburban.distanceDriveFareList': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
    'suburban.timeDriveFareList': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
    'suburban.areaDriveFareList': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
    'suburban.isWaitFare': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
    'suburban.timeWaitFareList': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
    'suburban.areaTimeWaitFareList': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
    'suburban.isAssistFare': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
    'suburban.timeAssistFareList': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
    'suburban.areaTimeAssistFareList': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
    'suburban.deliveryFareType': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
    'suburban.distanceDeliveryFareList': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
    'suburban.areaDeliveryFareList': {
      deep: true,
      handler() {
        this.makeSuburbanFare();
      }
    },
  }
}
</script>

<style scoped>

</style>
